import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  AddEmailAddressContent,
  OverlayMessage
} from './models/add-email-address.interface';

@Component({
  selector: 'idp-add-email-address',
  templateUrl: './add-email-address.component.html',
  styleUrls: ['./add-email-address.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddEmailAddressComponent implements OnInit, OnDestroy {
  altText = 'logo';

  logoUrl =
    'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png';

  addEmailAddressForm!: UntypedFormGroup;

  @Input() content: AddEmailAddressContent | null =
    {} as AddEmailAddressContent;

  @Output() resetForm: EventEmitter<void> = new EventEmitter<void>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() formSubmitEvent: EventEmitter<ElementRef> =
    new EventEmitter<ElementRef>();

  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();

  @Output() closeOverlayMessage: EventEmitter<OverlayMessage> =
    new EventEmitter();

  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(): void {
    this.addEmailAddressForm = this.content?.formGroup;
  }

  get showErrorMessageEmail(): boolean {
    const control = this.addEmailAddressForm.get('email') as UntypedFormControl;
    return control.invalid && this.content.formAttributes.emailControlTouched;
  }

  get emailControlErrors(): string {
    const [errorId] = Object.keys(this.addEmailAddressForm.get('email').errors);
    return errorId;
  }

  get confirmEmailControlErrors(): string {
    const [errorId] = Object.keys(this.confirmEmailControl.errors);
    return errorId;
  }

  get confirmEmailControl(): UntypedFormControl {
    return this.addEmailAddressForm.get('confirmEmail') as UntypedFormControl;
  }

  get showErrorMessageConfirmEmail(): boolean {
    const control = this.confirmEmailControl;
    return (
      control.invalid && this.content.formAttributes.confirmEmailControlTouched
    );
  }

  get showOnEmailsMismatch(): boolean {
    const control = this.confirmEmailControl;
    return (
      control.dirty &&
      this.content.formAttributes.confirmEmailControlTouched &&
      control.invalid
    );
  }

  get showOnEmailsMatch(): boolean {
    const control = this.confirmEmailControl;
    return (
      (control.dirty ||
        this.content.formAttributes.confirmEmailControlTouched) &&
      control.valid
    );
  }

  onFocusFirstInvalidField(): void {
    this.focusInvalidField.emit();
  }

  onChange(): void {
    this.inputChange.emit();
  }

  onFocussedOut(fieldName: string): void {
    this.fieldFocusOut.emit(fieldName);
  }

  onSubmit(): void {
    this.formSubmitEvent.emit();
  }

  onClosePopup(): void {
    this.closeOverlayMessage.emit({ isSuccess: false, isError: false });
  }

  ngOnDestroy() {
    this.resetForm.emit();
  }
}
